<template>
<header class="site-header">
  <img
    src="../../assets/logo.svg"
    alt="umbruch Logo"
    class="site-logo"
  >
</header>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.site-header {
  background-color: #B00000;
  clip-path: polygon(0 0,100% 0,100% calc(100% - 1.5rem),0 100%);
  padding: var(--site-padding);
}

.site-logo {
  max-width: 7.5rem;
  width: 25vw;
}
</style>
